module.exports = __webpack_public_path__ + "img/ZNZBZZYJC_5.c6216636.jpg";